import { render, staticRenderFns } from "./BillingProtocolsHome.vue?vue&type=template&id=282ed324&scoped=true&"
import script from "./BillingProtocolsHome.vue?vue&type=script&lang=js&"
export * from "./BillingProtocolsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ed324",
  null
  
)

export default component.exports